import React from 'react';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"
import {useAuth} from "../Contexts/AuthContexts"
import { useData } from '../Contexts/DataContext';



const TopbarPage = () => {

    const collector = useData();
  return (
    <div className="py-5 px-4 flex justify-between items-center">
        <h2 className="font-bold text-lg">{collector.user.firstName + " " + collector.user.lastName} • {collector.user.userType[0].toUpperCase() + collector.user.userType.substring(1)}</h2>
      </div>
  )
}

export default TopbarPage;
